import Layout from "@/views/main/Main.vue";
import type { RouteRecordRaw } from "vue-router";
const deliveryoutRouter: RouteRecordRaw = {
  path: "/deliveryout",
  component: Layout,
  redirect: "noredirect",
  meta: {
    icon: "el-icon-tickets",
    title: "单据出库"
  },
  children: [
    {
      path: '/deliveryout/allocateOrder',
      component: () => import("@/views/main/deliveryout/allocateOrder/allocateOrder.vue"),
      name: 'allocateOrder',
      meta: {
        title: '单据调拨（新增）'
      }
    },
    {
      path: '/deliveryout/returnStockTransfer',
      component: () => import("@/views/main/deliveryout/returnStockTransfer/returnStockTransfer.vue"),
      name: 'returnStockTransfer',
      meta: {
        title: '退库调拨'
      }
    },    
    {
      path: '/deliveryout/orderPrint',
      component: () => import("@/views/main/deliveryout/orderPrint/orderPrint.vue"),
      name: 'orderPrint',
      meta: {
        title: '单据调拨（打印）'
      }
    },
    // {
    //   path: '/deliveryout/allocateOrderBlack',
    //   component: () => import("@/views/main/deliveryout/allocateOrderBlack/allocateOrderBlack.vue"),
    //   name: 'allocateOrderBlack',
    //   meta: {
    //     title: '黑库单据调拨'
    //   }
    // },
    {
      path: '/deliveryout/Heterogeneous',
      component: () => import("@/views/main/deliveryout/Heterogeneous/Heterogeneous.vue"),
      name: 'Heterogeneous',
      meta: {
        title: '库位调拨'
      }
    },
    {
      path: '/deliveryout/assemble',
      component: () => import("@/views/main/deliveryout/assemble/assemble.vue"),
      name: 'assemble',
      meta: {
        title: '装配调拨'
      }
    },
    {
      path: '/deliveryout/sendgoods',
      component: () => import("@/views/main/deliveryout/sendgoods/sendgoods.vue"),
      name: 'sendgoods',
      meta: {
        title: '发货出库'
      }
    },
		{
		  path: '/deliveryout/virtualStore',
		  component: () => import("@/views/main/deliveryout/virtualStore/virtualStore.vue"),
		  name: 'sendManVStore',
		  meta: {
		    title: '虚拟库'
		  }
		},
    {
      path: '/deliveryout/delivery',
      component: () => import("@/views/main/deliveryout/delivery/delivery.vue"),
      name: 'delivery',
      meta: {
        title: '异库调拨'
      }
    },
    {
      path: '/deliveryout/exceptionLog',
      component: () => import("@/views/main/deliveryout/exceptionLog/exceptionLog.vue"),
      name: 'exceptionLog',
      meta: {
        title: '异库调拨'
      }
    },    
    {
      path: '/deliveryout/Inventory',
      component: () => import("@/views/main/deliveryout/Inventory/Inventory.vue"),
      name: 'Inventory',
      meta: {
        title: '盘点管理'
      }
    }
  ]
};

//单据管理
export default deliveryoutRouter;